<template>
    <div class="vx-row">
        <div v-for="(i, index) in marketplaceList" :key="index" class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base">
            <vx-card class="org-card marketplace--item-card overflow-hidden">
                <marketplace-item :title="i.title" :color="i.color" :description="i.description" :icon="i.icon" :data="i" />
            </vx-card>
        </div>
    </div>
</template>

<script>
import marketplaceList from '@/assets/data/user-marketplace-list.js';
import MarketplaceItem from './components/MarketplaceItem.vue'
export default {
  components: { MarketplaceItem },
  data() {
      return {
          marketplaceList
      }
  }
}
</script>

<style scoped>
    .marketplace--item-card:hover {        
        background: #FFFDF7!important;
        border: 1px solid rgba(242, 194, 68, 0.35)!important;
        box-shadow: 0px 8px 40px rgba(242, 194, 68, 0.05);
        transition: none;
    }
</style>